/** BizFlex primary brand linear gradient — single source of truth. */
export const BRAND_GRADIENT_START = '#2463EB';
export const BRAND_GRADIENT_END = '#143885';

export const BRAND_LINEAR_GRADIENT = `linear(to-b, ${BRAND_GRADIENT_START}, ${BRAND_GRADIENT_END})`;

export const brandGradientButtonStyles = {
  bgGradient: BRAND_LINEAR_GRADIENT,
  color: '#fff',
  border: 'none',
  _hover: {
    bgGradient: BRAND_LINEAR_GRADIENT,
    opacity: 0.92,
  },
  _active: {
    bgGradient: BRAND_LINEAR_GRADIENT,
    opacity: 0.88,
  },
  _focus: {
    bgGradient: BRAND_LINEAR_GRADIENT,
    boxShadow: 'none',
  },
  _disabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
};

export const brandGradientTextStyles = {
  bgGradient: BRAND_LINEAR_GRADIENT,
  bgClip: 'text',
  sx: {
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
};
